// Get Assignment Summary
export const GET_ASSIGNMENT_SUMMARY_REQUEST = 'GET_ASSIGNMENT_SUMMARY_REQUEST';
export const GET_ASSIGNMENT_SUMMARY_DONE = 'GET_ASSIGNMENT_SUMMARY_DONE';
export const GET_ASSIGNMENT_SUMMARY_FAILED = 'GET_ASSIGNMENT_SUMMARY_FAILED';
